import "./StatisticheAzienda.css";

const StatisticheAzienda = (props) => {
  return (
    <div className="statisticheAzienda">
      <div className="statistica-container colore1">
        <div className="titolo">
          Ordini
          <br />
          Gestiti
        </div>
        <div className="corpo">{props.Orders}+</div>
        <div className="unita-misura">mila</div>
      </div>
      <div className="statistica-container colore1">
        <div className="titolo">
          Ordini
          <br />
          ricevuti {new Date().getFullYear()-2}-{new Date().getFullYear()}
        </div>
        <div className="corpo">{props.Orders3Y}+</div>
        <div className="unita-misura">mila</div>
      </div>
      
      <div className="statistica-container colore3">
        <div className="titolo">
          Simple
          <br />
          prodotti
        </div>
        <div className="corpo">{props.Simples}</div>
        <div className="unita-misura">unità</div>
      </div>
      <div className="statistica-container colore4">
        <div className="titolo">
          Prodotti
          <br />
          sul MEPA
        </div>
        <div className="corpo">{props.Published}+</div>
        <div className="unita-misura">mila</div>
      </div>
    </div>
  );
};

export default StatisticheAzienda;
